const isEven = (value) => value % 2 === 0;
const isHalf = (value) => {
  const epsilon = 1e-8;
  const remainder = Math.abs(value) % 1;

  return remainder > .5 - epsilon && remainder < .5 + epsilon;
};

const roundHalfToEvenShifted = (value, factor) => {
  const shifted = value * factor;
  const rounded = Math.round(shifted);
  const modifier = value < 0 ? -1 : 1;

  return !isEven(rounded) && isHalf(shifted) ? rounded - modifier : rounded;
};

const roundHalfToEven = (digits, unshift) => {
  const factor = 10 ** digits;

  return unshift
    ? (value) => roundHalfToEvenShifted(value, factor) / factor
    : (value) => roundHalfToEvenShifted(value, factor);
};

export const roundDollarsToCents = roundHalfToEven(2, false);
export const roundCurrency = roundHalfToEven(2, true);

